import { useTranslation } from 'react-i18next';

export default function SchoolSection() {
  const { t } = useTranslation('common');
  
  const programs = [
    {
      icon: 'ri-music-2-line',
      title: t('training.program1Title'),
      description: t('training.program1Desc'),
    },
    {
      icon: 'ri-book-open-line',
      title: t('training.program2Title'),
      description: t('training.program2Desc'),
    },
    {
      icon: 'ri-team-line',
      title: t('training.program3Title'),
      description: t('training.program3Desc'),
    },
    {
      icon: 'ri-heart-pulse-line',
      title: t('training.program4Title'),
      description: t('training.program4Desc'),
    },
  ];

  return (
    <section id="training" className="py-32 px-6 bg-black relative">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-gradient-to-br from-amber-500 to-orange-600"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-20">
          <div className="inline-block px-4 py-2 bg-amber-500/10 border border-amber-500/30 rounded-full mb-6">
            <span className="text-amber-500 text-sm font-semibold uppercase tracking-wider">{t('training.badge')}</span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-8 leading-tight">
            {t('training.title')}
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            {t('training.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
          {programs.map((program, index) => (
            <div
              key={index}
              className="bg-zinc-900/50 backdrop-blur-sm border border-zinc-800 rounded-2xl p-8 hover:border-amber-500/50 transition-all duration-300 group cursor-pointer"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-amber-500/10 rounded-xl mb-6 group-hover:bg-amber-500/20 transition-colors">
                <i className={`${program.icon} text-3xl text-amber-500`}></i>
              </div>
              <h3 className="text-xl font-bold mb-4">{program.title}</h3>
              <p className="text-gray-400 leading-relaxed">{program.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-amber-500 to-orange-600 rounded-3xl p-12 md:p-16 text-center">
          <h3 className="text-3xl md:text-4xl font-bold mb-6 text-black">
            {t('training.comingSoonTitle')}
          </h3>
          <p className="text-lg md:text-xl text-black/80 mb-8 max-w-2xl mx-auto">
            {t('training.comingSoonSubtitle')}
          </p>
          <div className="px-10 py-4 bg-black text-white font-semibold rounded-lg whitespace-nowrap text-base inline-block opacity-60 cursor-not-allowed">
            {t('training.comingSoonBtn')}
          </div>
        </div>
      </div>
    </section>
  );
}